export default __webpack_public_path__ + "static/media/AvatarKids-11.7d33016f.png";